export const messages = {
  complexBiology: 'Complex Biology Without the Complex Workflows',
  copyright: `\u00A9 ${new Date().getFullYear()} University of Pittsburgh. Used under license`,
  help: 'Help',
  feedback: 'Feedback',
  termsConditions: 'Terms & Conditions',
  privacyPolicy: 'Privacy Policy',
};
